<template>
    <views
        :class="{'white': whiteBg}"
        class="person-item"
        @click="onClick">
        <views class="person-item-icon">
            <images :src="icon"></images>
        </views>
        <views class="person-item-title">{{ title }}</views>
        <views class="person-item-arrow">
            <images :src="arrow"></images>
        </views>
    </views>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '标题'
        },
        icon: {
            type: String,
            default: ''
        },
        whiteBg: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            arrow: require('@/assets/images/awr.png')
        }
    },
    methods: {
        onClick() {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
